export class LogEvent {
    EventCode: number;
    EventDescription: string;

    constructor(code: number, description: string) {
        this.EventCode = code;
        this.EventDescription = description;
    }
}

export const LOG_EVENTS = {
    InvitationOffer: new LogEvent(1, 'InvitationOffer'),
    InvitationAccept: new LogEvent(2, 'InvitationAccept'),
    InvitationDecline: new LogEvent(3, 'InvitationDecline'),
    InvitationTimeOut: new LogEvent(4, 'InvitationTimeOut'),
    ChatFormOffer: new LogEvent(5, 'ChatFormOffer'),
    ChatFormDecline: new LogEvent(6, 'ChatFormDecline'),
    ChatFormSubmit: new LogEvent(7, 'ChatFormSubmit')
}